import { isInViewport } from '../helpers';

// Autofocus the company lead full name field unless the referral modal is visible
const companyLeadFullName = document.getElementById('company_lead_full_name');
if (isInViewport(companyLeadFullName)) {
  const referralModalClasses = document.getElementsByClassName('referral-modal');
  if (referralModalClasses && referralModalClasses.length === 0) {
    companyLeadFullName.focus();
  }
}
